import styled from 'styled-components';

export const BlockTitle = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const BlockTitleIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const FieldsGrid = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 24px;
  row-gap: 16px;
`;

export const LabeledField = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const FieldLabel = styled.label`
  display: flex;
  column-gap: 4px;

  font: ${({ theme }) => theme.fonts.textSmall};
  color: ${({ theme }) => theme.colors.greys.darkest};
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;

  background-color: ${({ theme }) => theme.colors.greys.light};
`;
